import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeActivitiesAnalyticalPerTaskColumns = (): IColumn[] => {
  const { getLegends } = useLegends();

  return [
    {
      title: getLegends('GRUPO', false),
      dataKey: 'group',
      width: 270,
    },
    {
      title: getLegends('ESTUDANTE', false),
      dataKey: 'student',
      width: 200,
    },
    {
      title: getLegends('LOCAL_ESTAGIO', false),
      dataKey: 'place',
      width: 240,
    },

    {
      title: 'Início',
      dataKey: 'started',
    },
    {
      title: 'Término',
      dataKey: 'finished',
    },
    {
      title: 'Duração',
      dataKey: 'workload',
    },

    {
      title: 'Validação',
      dataKey: 'validation',
    },
  ];
};
